const modal = {
  dom: function() {
    this.$activeModal = undefined;
    this.$smallModals = undefined;
    this.modalDataId = 'data-modal-id';
    this.$modalToggle = $('[data-toggle="modal"]');
    this.$modalToggle2 = $('[data-toggle="modal2"]');
    this.$modal = $('[data-js-hook="modal"]');
    this.$close = '[data-dismiss="modal"]';
    this.$select = $('[data-modal-current]');
    this.$ajaxModalTrigger = $('[data-toggle="ajax-modal');
  },

  close: function() {
    if (modal.$activeModal) {
      modal.$activeModal.removeClass('show').fadeOut(function() {
        $('body').removeClass('modal-open');
      });
      modal.$activeModal = null;
      setTimeout(function() {
        const $modal = $('[' + modal.modalDataId + ']');
        if ($modal.length) {
          $modal.hide();
          $('[' + modal.modalDataId + '="1"]').show();
          if (modal.$smallModals !== undefined && modal.$smallModals.length) {
            $.each(modal.$smallModals, function() {
              $(this).find('.modal__container').addClass('modal__container--no-width');
            });
          }
        }
      }, 500);
    }
  },

  open: function($target) {
    modal.$activeModal = $target;
    $('body').addClass('modal-open');
    modal.$activeModal.fadeIn(function() {
      $(this).addClass('show');
    });
  },

  showHideModal: function() {
    this.$modalToggle.on('click', function(e) {
      if (!e.ctrlKey && !e.metaKey) {
        e.preventDefault();

        const target = $(this).data('target');
        const embed = $(target).find('.modal__iframe-wrap');

        if ($(target).length) {
          if ($(target).is(':visible')) {
            modal.close($(target));
          }
          else {
            if (embed.length) {
              embed.each(function() {
                const $this = $(this);
                if (!$this.children('iframe').length) {
                  $this.append(decodeURIComponent($this.data('embed-code')));
                  setTimeout(function() {
                    $('.modal__loading', $this).fadeOut();
                  }, 2000);
                }
              });
            }
            else {
              $('.modal__loading', $(target)).fadeOut();
            }

            modal.close();

            // target specific page in modal
            const page = $(this).data('modal-page');
            if (typeof page != 'undefined' && $('.modal__page[data-modal-id="' + page + '"]', target).length) {
              $('.modal__page', target).hide();
              $('.modal__page[data-modal-id="' + page + '"]', target).show();
              $(target).find('.modal__container--no-width').removeClass('modal__container--no-width');
            }

            modal.open($(target));
          }
        }
      }
    });
  },

  showHideModal2: function() {
    let allowModal = true;
    let mouseX = undefined;
    let href = '';

    function resetSettings() {
      allowModal = true;
      mouseX = undefined;
    }

    function getMousePosition(event) {
      event.preventDefault();
      href = $(this).attr('href');
      mouseX = event.clientX;
    }

    function checkAllow(event) {
      if (mouseX !== undefined) {
        allowModal = Math.abs(mouseX - event.clientX) < 5;
      }
    }

    this.$modalToggle.on('mousedown', getMousePosition);
    this.$modalToggle.on('mousemove', checkAllow);

    this.$modalToggle2.on('mouseup', function(e) {
      if (!allowModal) {
        resetSettings();
        return;
      }

      const target = $(this).data('target');
      const embed = $(target).find('.modal__iframe-wrap');
      if ($(target).length) {
        if ($(target).is(':visible')) {
          modal.close($(target));
        }
        else {
          if (embed.length) {
            embed.each(function() {
              const $this = $(this);
              if (!$this.children('iframe').length) {
                $this.append(decodeURIComponent($this.data('embed-code')));
                setTimeout(function() {
                  $('.modal__loading', $this).fadeOut();
                }, 2000);
              }
            });
          }
          else {
            $('.modal__loading', $(target)).fadeOut();
          }

          modal.close();

          // target specific page in modal
          const page = $(this).data('modal-page');
          if (typeof page != 'undefined' && $('.modal__page[data-modal-id="' + page + '"]', target).length) {
            $('.modal__page', target).hide();
            $('.modal__page[data-modal-id="' + page + '"]', target).show();
            $(target).find('.modal__container--no-width').removeClass('modal__container--no-width');
          }

          modal.open($(target));
        }
      }
      resetSettings();
    });
  },

    closeModal: function() {
      const _ = this;

      $(".modal__close").on("click", function(event) {
        event.preventDefault();
        modal.close();
      });

      $(document).keyup(function(event) {
        if (event.key === "Escape" && typeof modal.$activeModal !== 'undefined') {
          modal.close();
        }
      });
  },

  navigateModal: function() {
    this.$modal.each(function() {
      const $this = $(this);
      const $buttons = $('[data-js-hook="modal-page-button"]', $this);
      const $pages = $('[data-modal-id]', $this);
      const $nav = $('[data-modal-button]', $this);

      if ($this.children('.modal__container').hasClass('modal__container--no-width')) {
        modal.$smallModals.push($this);
      }

      $nav.click(function(event) {
        event.preventDefault();
        const $parent = $(this).closest('[data-modal-id]');
        $parent.hide();

        if ($(this).data('modal-button') === 'next') {
          $parent.next().show();
        }
        else if ($(this).data('modal-button') === 'previous') {
          $parent.prev().show();
        }
      });

      if ($buttons.length && $pages.length) {
        $buttons.click(function(event) {
          event.preventDefault();
          const target = $(this).data('target');
          const $current = $(this).closest('[data-modal-id]');
          const currentId = $current.data('modal-id');

          $pages.filter('[data-modal-id="' + currentId + '"]').hide();
          $pages.filter('[data-modal-id="' + target + '"]').show();

          $('.modal__nav-items').hide();

          if ($(this).closest('.modal__container').hasClass('modal__container--no-width')) {
            $(this).closest('.modal__container').removeClass('modal__container--no-width');
          }
        });
      }
    });

    this.$select.click(function(event) {
      event.preventDefault();
      if ($(this).next().is(':visible')) {
        $('.modal__nav-items').hide();
      }
      else {
        $('.modal__nav-items').hide();
        $(this).next().slideDown();
      }
    });
  },

  autoModal: function() {
    if (window.location.search !== 'undefined') {
      const urlParams = window.location.search.replace('?', '');
      const aUrlParams = urlParams.split('&');
      let target = false;

      $.each(aUrlParams, function(key, value) {
        const aParamSplit = value.split('=');
        if (aParamSplit[0] === 'modal') {
          target = aParamSplit[1];
        }
      });

      if (target) {
        modal.open($('#' + target));
      }
    }
  },

  ajaxModal: function() {
    this.$ajaxModalTrigger.click(function(e) {
      e.preventDefault();

      let data = [];
      const name = $(this).data('toggle');
      const url = $(this).data('target');
      const $modal = $('#' + name);
      const $content = $modal.find('.modal-content');
      const $loader = $modal.find('.modal__loader');
      const $modalClose = $modal.find('[data-dismiss="modal"]');

      modal.open($modal);

      const sParams = url.substring(url.indexOf('?') + 1);
      const aParamsTemp = sParams.split('&');
      aParamsTemp.forEach(function(value) {
        const aParam = value.split('=');
        const param = aParam[0];
        value = aParam[1];
        data[param] = value;
      });

      $content.load(
        url,
        {data: data},
        function(response, status) {
          if (status !== 'error') {
            $loader.fadeOut(function() {
              $content.fadeIn();
            });
          }
        }
      );

      $modalClose.click(function() {
        $content.fadeOut(function() {
          $content.html('');
          $loader.show();
        });
      });

    });
  },

  ready: function() {
    this.dom();
    this.showHideModal();
    this.showHideModal2();
    this.navigateModal();
    this.autoModal();
    this.ajaxModal();
    this.closeModal();
  }
};

$(function() { modal.ready(); });
